import { Button } from '../../../cdl/Button/Button';
import { StatePlaceholder } from '../../../cdl/StatePlaceholder/StatePlaceholder';
import { translate } from '../../../common/helpers/translate.helper';
import { useOpenFreshchat } from '../../../common/hooks/useOpenFreshchat';
import { IconCalendarPin } from '../../../common/icons/cdl/CalendarPin';
import { Box } from '../../../common/ui/Box';

export const ScheduleEmptyState = () => {
    const openFreshchat = useOpenFreshchat();

    return (
        <Box display="flex" justifyContent="center" paddingTop="124px">
            <StatePlaceholder
                title={translate('schedule.unavailable.title')}
                description={translate('schedule.unavailable.description')}
                Icon={IconCalendarPin}
                action={<Button onClick={openFreshchat}>{translate('navigation.messageUs')}</Button>}
            />
        </Box>
    );
};
